import { createContext, useContext, useState, useCallback } from 'react'
import { Box, Typography } from '@mui/material'
import { StateModal } from '@/modules/onboarding-form/components/onboarding-wizard/StateModal'

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: null,
    onClose: () => {},
    resolutionType: null, // (e.g., "confirm", "alert") 
    props: {}
  })
  const [resolvePromise, setResolvePromise] = useState(null);

  const showModal = useCallback(({ type, resolutionType, onClose = () => {} }, props) => {
    setModalState({ isOpen: true, type, resolutionType, props, onClose })
    if (resolutionType === 'confirm') {
        return new Promise((resolve) => {
            setResolvePromise(() => resolve);
        });
    }
  }, [])

  const closeModal = useCallback(() => {
    setModalState((prevState) => ({
      ...prevState,
      isOpen: false,
    }))
    modalState.onClose()
  }, [modalState])

  const handleConfirm = useCallback(
    (confirmed) => {
      if (resolvePromise) {
        resolvePromise(confirmed);
      }
      closeModal();
    },
    [resolvePromise, closeModal]
  );

  const RenderModal = () => {
    if (!modalState.isOpen) return null
    switch (modalState.type) {
      case 'state':
        return (
          <StateModal
            sx={{ width: '480px' }}
            isOpen={modalState.isOpen}
            title={
              <Box>
                <Typography
                  component={'span'}
                  fontSize={40}
                >
                  👋
                </Typography>
                <Typography
                  fontSize={20}
                  fontWeight={600}
                >
                  Hello, welcome back!
                </Typography>
              </Box>
            }
            content={
              <Typography
                variant='body1'
                color='textSecondary'
                width={350}
                marginX={'auto'}
              >
                We’ve saved where you left off so that you can continue making
                your new website.
              </Typography>
            }
            actionsSx={{ flexDirection: 'column', gap: '10px' }}
            onClose={handleConfirm}
          />
        )
      default:
        return null
    }
  }

  return (
    <ModalContext.Provider value={{ showModal, closeModal }}>
      {children}
      <RenderModal />
    </ModalContext.Provider>
  )
}

export const useModal = () => useContext(ModalContext)
